import type { GetDnsResponse } from '@fourthwall/services/dist/DnsApiClient'
import { useEntriContext } from '@modules/Dashboard/pages/Settings/pages/Domain/providers/Entri'
import { useMutation } from '@tanstack/react-query'

import { getEntriConfig } from '../utils/getEntriConfig'

type MutationPayload = {
  dnsList: NonNullable<GetDnsResponse['dnsList']>
  shopId: string
}

export const useDetectDomainProviderGetMutation = () => {
  const { checkDomain } = useEntriContext()
  const detectDomainProviderGetMutation = useMutation({
    mutationFn: async ({ dnsList, shopId }: MutationPayload) => {
      const config = getEntriConfig(dnsList, shopId)
      const domainType = await checkDomain(dnsList.domain, config)

      return {
        config,
        domainType,
      }
    },
  })

  return {
    detectDomainProviderGetMutation,
  }
}
